module.exports = __webpack_public_path__ + "img/lootbox-common.36f07176.jpg";